<div style="position: relative" id="portal-outlet"></div>
<div #layoutWrapperMenu class="min-h-screen">
    <!-- Закрытая часть системы -->
    <ng-container *ngIf="!this.appService.isPublic; else publicPage">
        <!-- Боковое меню закрытой части системы -->
        <div [fxFlex]="getAdminMenuFlex()">
            <div class="layout-wrapper-left" [fxHide]="!appService.showSideMenu.value">
                <app-side-menu></app-side-menu>
            </div>
        </div>
        <!-- Основа страницы -->
        <div [fxFlex]="getAdminContentFlex()" fxLayout="column" fxLayoutAlign="start">
            <div #adminContainer fxFlex="1 1 100%" fxLayout="column" fxLayoutAlign="start">
                <!-- Хедер -->
                <app-header
                    [routeData]="appService.routeData"
                    [isPublic]="appService.isPublic"
                    [layoutWrapperContainer]="layoutWrapperMenu"
                    [ngStyle.lt-md]="'z-index: 250'"
                >
                </app-header>
                <!-- Хлебные крошки -->
                <app-breadcrumbs></app-breadcrumbs>
                <!-- Основная страница -->
                <div fxFlex="auto" class="main-content flex flex-col">
                    <div class="app-route-container">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <!-- Общедоступная часть системы -->
    <ng-template #publicPage>
        <!-- Основа страницы -->
        <div fxFlex="0 0 100%" class="container" fxLayout="column" fxLayoutAlign="start">
            <!-- Хедер -->
            <app-header
                [routeData]="appService.routeData"
                [isPublic]="appService.isPublic"
                [layoutWrapperContainer]="layoutWrapperMenu"
                style="z-index: 7"
            ></app-header>
            <!-- Основная страница -->
            <div #publicContainer fxFlex="1 1 100%" class="overflow-x-hidden">
                <div fxFill class="app-route-container">
                    <router-outlet name="public"></router-outlet>
                </div>
            </div>
            <!-- Футер -->
            <app-footer class="public-footer"> </app-footer>
        </div>
    </ng-template>
    <app-scroll-top [element]="'body'"></app-scroll-top>
</div>
<ngx-spinner bdColor="transparent" [template]="spinnerHtml"></ngx-spinner>
